// src/api.js
function getApiOrigin() {
  // Même origine que le front (Apache → Node :5000) : login, /api/cvs, etc. utilisent le même JWT que le proxy parse.
  if (process.env.REACT_APP_PARSE_USE_RELATIVE === 'true') {
    return '';
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  const base =
    process.env.REACT_APP_API_BASE_URL || 'https://server.consult-it.com/api';
  return base.replace(/\/api\/?$/, '').replace(/\/$/, '') || 'https://server.consult-it.com';
}

const API_BASE_URL = getApiOrigin();
export default API_BASE_URL;

/** URL du service parse via le proxy Express (/api/parse → parse.consult-it.com) */
export function parseProxyUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  // Même origine (Apache proxifie /api/ → Node) : évite CORS en prod sur parsing.consult-it.com
  if (process.env.REACT_APP_PARSE_USE_RELATIVE === 'true') {
    return `/api/parse${p}`;
  }
  return `${API_BASE_URL}/api/parse${p}`;
}
